/**
 * AV API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GrundstueckId } from './grundstueckId';


export interface LoadGeoGeschaeftSichtByGrundstueckIdsRequest { 
    grundstueckIds?: Array<GrundstueckId>;
    auftragLoadOption?: LoadGeoGeschaeftSichtByGrundstueckIdsRequest.AuftragLoadOptionEnum;
    offset?: number;
    limit?: number;
    sortDirection?: LoadGeoGeschaeftSichtByGrundstueckIdsRequest.SortDirectionEnum;
    sort?: LoadGeoGeschaeftSichtByGrundstueckIdsRequest.SortEnum;
}
export namespace LoadGeoGeschaeftSichtByGrundstueckIdsRequest {
    export type AuftragLoadOptionEnum = 'ALLE' | 'HAENGIGE';
    export const AuftragLoadOptionEnum = {
        ALLE: 'ALLE' as AuftragLoadOptionEnum,
        HAENGIGE: 'HAENGIGE' as AuftragLoadOptionEnum
    };
    export type SortDirectionEnum = 'ASC' | 'DESC';
    export const SortDirectionEnum = {
        ASC: 'ASC' as SortDirectionEnum,
        DESC: 'DESC' as SortDirectionEnum
    };
    export type SortEnum = 'NUMMER' | 'STATUS' | 'AUFTRAG_DATUM' | 'AV_MUTATION' | 'GESCHAEFT_ART';
    export const SortEnum = {
        NUMMER: 'NUMMER' as SortEnum,
        STATUS: 'STATUS' as SortEnum,
        AUFTRAG_DATUM: 'AUFTRAG_DATUM' as SortEnum,
        AV_MUTATION: 'AV_MUTATION' as SortEnum,
        GESCHAEFT_ART: 'GESCHAEFT_ART' as SortEnum
    };
}


